import { render, staticRenderFns } from "./orderDetailEtcInvoice.vue?vue&type=template&id=1dd97bac&scoped=true"
import script from "./orderDetailEtcInvoice.vue?vue&type=script&lang=js"
export * from "./orderDetailEtcInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd97bac",
  null
  
)

export default component.exports